// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tour-info page-section .section .sub-section .language-container, tour-info page-section .section .sub-section .action-container {
  display: flex;
  flex-wrap: wrap;
  gap: var(--small-spacing);
}
tour-info page-section .section .sub-section .language-container button, tour-info page-section .section .sub-section .action-container button {
  margin: 0;
}
tour-info page-section .section .sub-section .action-container .action-button {
  white-space: nowrap;
  flex-basis: 100px;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
tour-info page-section .section .sub-section .language-container {
  margin-bottom: var(--small-spacing);
}
tour-info page-section .section .sub-section .language-container .one-lang {
  font-family: var(--header-font);
  text-decoration: none;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 15px;
}
tour-info page-section .section .sub-section .icons {
  display: flex;
  flex-wrap: wrap;
  gap: var(--small-spacing) var(--large-spacing);
  margin-bottom: var(--large-spacing);
}
tour-info page-section .section .sub-section .icons svg-icon {
  margin-right: 8px;
  font-size: 18px;
}
tour-info page-section .section .sub-section .icons p {
  margin: 0;
}
tour-info page-section .section .sub-section.dynamic-text mini-voucher {
  text-align: left;
}
tour-info page-section .section .sub-section .product-container {
  display: flex;
  justify-content: center;
  width: 100%;
}
tour-info page-section .section .sub-section .product-container mini-voucher {
  margin: var(--motes-padding);
  min-width: 300px;
}
tour-info page-section .section .sub-section .product-container mini-voucher .image-container {
  cursor: default;
}
tour-info page-section .section .sub-section .product-container mini-voucher:not(:only-of-type) {
  width: 100%;
}
tour-info page-section .section .sub-section .scroll-container > * {
  justify-content: center;
}
tour-info page-section .section .sub-section .scroll-container .media {
  position: relative;
  height: -moz-fit-content;
  height: fit-content;
  border: none;
}
tour-info page-section .section .sub-section .scroll-container .media p {
  position: absolute;
  bottom: 0;
  text-align: left;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
  margin: 0;
  padding: 10px;
  text-shadow: 0 0 5px black;
  color: white;
  width: 100%;
  box-sizing: border-box;
  max-height: 100%;
  font-size: 16px;
  line-height: 23px;
  pointer-events: none;
}
tour-info page-section .section .sub-section.map-overlay {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  pointer-events: none;
}
tour-info page-section .section .sub-section.map-overlay button {
  margin: 0;
  pointer-events: initial;
}
tour-info page-section .section .sub-section.image.map {
  min-width: 100%;
  min-height: 300px;
  height: 45vh;
  align-items: center;
  cursor: pointer;
}
tour-info page-section .section .sub-section.media-redirect #media-container {
  cursor: pointer;
}
tour-info page-section .section .sub-section .expandable-boxes {
  --box-pr-row: 1;
  display: grid;
  grid-template-columns: repeat(var(--box-pr-row), auto);
  grid-gap: var(--large-spacing);
}
@media all and (min-width: 900px) {
  tour-info page-section .section .sub-section .expandable-boxes {
    --box-pr-row: 2;
  }
}
tour-info page-section .section .sub-section .expandable-boxes .box {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  column-gap: var(--large-spacing);
  height: min-content;
  padding: var(--large-spacing);
  box-sizing: border-box;
  border-radius: var(--border-radius);
  background-color: var(--motes-light-gray);
  text-align: left;
  cursor: pointer;
}
tour-info page-section .section .sub-section .expandable-boxes .box h4, tour-info page-section .section .sub-section .expandable-boxes .box p {
  font-size: 16px;
  line-height: 22px;
}
tour-info page-section .section .sub-section .expandable-boxes .box h4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
tour-info page-section .section .sub-section .expandable-boxes .box p {
  margin: 0;
  overflow: hidden;
  max-height: 0;
  transition: 0.2s max-height;
}
tour-info page-section .section .sub-section .expandable-boxes .box svg-icon {
  transition: 0.2s transform;
}
tour-info page-section .section .sub-section .expandable-boxes .box.open p {
  max-height: 100px;
}
tour-info page-section .section .sub-section .expandable-boxes .box.open svg-icon {
  transform: rotate(180deg);
}
tour-info page-section .section .sub-section .tour-summary {
  margin-bottom: var(--medium-spacing);
}
tour-info page-section .section .sub-section .tour-summary p {
  font-size: 16px;
}
tour-info .first-section #media-container {
  height: 100%;
}
tour-info .first-section #media-container .image-container {
  height: 100%;
}
tour-info .first-section #media-container .image-container img {
  height: 100%;
  object-fit: cover;
}
tour-info .start-tour-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
tour-info .start-tour-drawer {
  position: fixed;
  z-index: 1;
  bottom: -500px;
  transition: 0.5s bottom;
  width: 100%;
  border-radius: 20px 20px 0 0;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0px -5px 15px rgba(34, 34, 34, 0.4509803922);
}
tour-info .start-tour-drawer.open {
  bottom: 0;
}
tour-info .start-tour-drawer .start-tour-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
tour-info .start-tour-drawer .start-tour-option h3 {
  flex: 1;
  margin-bottom: 10px;
  margin-right: 10px;
}
tour-info .start-tour-drawer .start-tour-option button {
  width: 120px;
}
tour-info .start-tour-drawer .start-tour-option svg-icon {
  width: 50px;
  height: 50px;
  margin-right: var(--motes-padding);
  border-radius: var(--border-radius);
  text-align: center;
  display: flex;
  align-items: center;
  background-color: white;
}
tour-info .start-tour-drawer .start-tour-option svg-icon svg {
  width: 68%;
  height: 68%;
}
tour-info .start-tour-drawer .start-tour-option svg-icon[name=motes] {
  background-color: black;
  color: white;
}
tour-info .start-tour-drawer .start-tour-option svg-icon[name=motes] svg {
  width: 70%;
  height: 70%;
}
@media only screen and (min-width: 1025px) {
  tour-info .first-section .section > .sub-section.padded-left {
    padding-top: 2vh;
    padding-bottom: 2vh;
  }
  tour-info .first-section h1 {
    margin-top: 0;
    font-size: 35px;
    line-height: 43px;
  }
  tour-info .first-section .icons p {
    font-size: 16px;
    line-height: 23px;
  }
  tour-info .first-section .language-container {
    padding-top: var(--header-height);
  }
}
@media only screen and (max-width: 1025px) {
  tour-info .first-section .icons svg-icon {
    font-size: 25px;
  }
}
@media only screen and (max-width: 600px) {
  tour-info .section .sub-section.dynamic-text {
    width: initial;
  }
  tour-info .section .sub-section.dynamic-text .product-container {
    flex-wrap: wrap;
  }
  tour-info .section .sub-section.dynamic-text .product-container mini-voucher {
    width: 100%;
    margin: 0;
  }
  tour-info .section .sub-section.image.map {
    height: 50vh;
  }
  tour-info .section .sub-section.image.map motes-media {
    height: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/modules/tour-info/tour-info.component.scss"],"names":[],"mappings":"AAOY;EACI,aAAA;EACA,eAAA;EACA,yBAAA;AANhB;AAQgB;EACI,SAAA;AANpB;AAYgB;EACI,mBAAA;EACA,iBAAA;EACA,2BAAA;EAAA,sBAAA;AAVpB;AAcY;EACI,mCAAA;AAZhB;AAcgB;EACI,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAZpB;AAgBY;EACI,aAAA;EACA,eAAA;EACA,8CAAA;EACA,mCAAA;AAdhB;AAgBgB;EACI,iBAAA;EACA,eAAA;AAdpB;AAiBgB;EACI,SAAA;AAfpB;AAmBY;EACI,gBAAA;AAjBhB;AAoBY;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AAlBhB;AAoBgB;EACI,4BAAA;EACA,gBAAA;AAlBpB;AAoBoB;EACI,eAAA;AAlBxB;AAqBoB;EACI,WAAA;AAnBxB;AA0BgB;EACI,uBAAA;AAxBpB;AA2BgB;EACI,kBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,YAAA;AAzBpB;AA2BoB;EACI,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,2FAAA;EACA,SAAA;EACA,aAAA;EACA,0BAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAzBxB;AA8BY;EACI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AA5BhB;AA8BgB;EACI,SAAA;EACA,uBAAA;AA5BpB;AAgCY;EACI,eAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AA9BhB;AAiCY;EACI,eAAA;AA/BhB;AAkCY;EACI,eAAA;EAGA,aAAA;EACA,sDAAA;EACA,8BAAA;AAlChB;AA8BgB;EAFJ;IAEyC,eAAA;EA1BnD;AACF;AA+BgB;EACI,aAAA;EACA,+BAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,6BAAA;EACA,sBAAA;EACA,mCAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;AA7BpB;AA+BoB;EACI,eAAA;EACA,iBAAA;AA7BxB;AAgCoB;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AA9BxB;AAiCoB;EACI,SAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;AA/BxB;AAkCoB;EACI,0BAAA;AAhCxB;AAoCwB;EACI,iBAAA;AAlC5B;AAqCwB;EACI,yBAAA;AAnC5B;AAyCY;EACI,oCAAA;AAvChB;AAyCgB;EACI,eAAA;AAvCpB;AA8CQ;EACI,YAAA;AA5CZ;AA8CY;EACI,YAAA;AA5ChB;AA8CgB;EACI,YAAA;EACA,iBAAA;AA5CpB;AAkDI;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAhDR;AAmDI;EACI,eAAA;EACA,UAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,wDAAA;AAjDR;AAmDQ;EACI,SAAA;AAjDZ;AAoDQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAlDZ;AAoDY;EACI,OAAA;EACA,mBAAA;EACA,kBAAA;AAlDhB;AAqDY;EACI,YAAA;AAnDhB;AAsDY;EACI,WAAA;EACA,YAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApDhB;AAsDgB;EACI,UAAA;EACA,WAAA;AApDpB;AAuDgB;EACI,uBAAA;EACA,YAAA;AArDpB;AAuDoB;EACI,UAAA;EACA,WAAA;AArDxB;AA6DI;EAEQ;IACI,gBAAA;IACA,mBAAA;EA5Dd;EA+DU;IACI,aAAA;IACA,eAAA;IACA,iBAAA;EA7Dd;EAgEU;IACI,eAAA;IACA,iBAAA;EA9Dd;EAiEU;IACI,iCAAA;EA/Dd;AACF;AAoEI;EAEQ;IACQ,eAAA;EAnElB;AACF;AAwEI;EAGQ;IACI,cAAA;EAxEd;EA0Ec;IACI,eAAA;EAxElB;EA0EkB;IACI,WAAA;IACA,SAAA;EAxEtB;EA6EU;IACI,YAAA;EA3Ed;EA6Ec;IACI,YAAA;EA3ElB;AACF","sourcesContent":["\ntour-info {\n\n    page-section .section {\n\n        .sub-section {\n\n            .language-container, .action-container {\n                display: flex;\n                flex-wrap: wrap;\n                gap: var(--small-spacing);\n\n                button {\n                    margin: 0;\n                }\n            }\n\n            .action-container {\n\n                .action-button {\n                    white-space: nowrap;\n                    flex-basis: 100px;\n                    min-width: fit-content;\n                }\n            }\n\n            .language-container {\n                margin-bottom: var(--small-spacing);\n\n                .one-lang {\n                    font-family: var(--header-font);\n                    text-decoration: none;\n                    font-weight: bold;\n                    text-transform: uppercase;\n                    font-size: 15px;\n                }\n            }\n            \n            .icons {\n                display: flex;\n                flex-wrap: wrap;\n                gap: var(--small-spacing) var(--large-spacing);\n                margin-bottom: var(--large-spacing);\n        \n                svg-icon {\n                    margin-right: 8px;\n                    font-size: 18px;\n                }\n\n                p {\n                    margin: 0;\n                }\n            }\n\n            &.dynamic-text mini-voucher {\n                text-align: left;\n            }\n\n            .product-container {\n                display: flex;\n                justify-content: center;\n                width: 100%;\n\n                mini-voucher {\n                    margin: var(--motes-padding);\n                    min-width: 300px;\n\n                    .image-container {\n                        cursor: default;\n                    }\n\n                    &:not(:only-of-type) {\n                        width: 100%;\n                    }\n                }\n            }\n            \n            .scroll-container {\n\n                > * {\n                    justify-content: center;\n                }\n\n                .media {\n                    position: relative;\n                    height: fit-content;\n                    border: none;\n        \n                    p {\n                        position: absolute;\n                        bottom: 0;\n                        text-align: left;\n                        background: linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));\n                        margin: 0;\n                        padding: 10px;\n                        text-shadow: 0 0 5px black;\n                        color: white;\n                        width: 100%;\n                        box-sizing: border-box;\n                        max-height: 100%;\n                        font-size: 16px;\n                        line-height: 23px;\n                        pointer-events: none;\n                    }\n                }\n            }\n\n            &.map-overlay {\n                position: absolute;\n                z-index: 1;\n                display: flex;\n                align-items: flex-end;\n                justify-content: flex-end;\n                width: 100%;\n                height: 100%;\n                padding: 20px;\n                box-sizing: border-box;\n                pointer-events: none;\n\n                button {\n                    margin: 0;\n                    pointer-events: initial;\n                }\n            }\n\n            &.image.map {\n                min-width: 100%;\n                min-height: 300px;\n                height: 45vh;\n                align-items: center;\n                cursor: pointer;\n            }\n\n            &.media-redirect #media-container {\n                cursor: pointer;\n            }\n\n            .expandable-boxes {\n                --box-pr-row: 1;\n                @media all and (min-width: 900px)  { --box-pr-row: 2; }\n\n                display: grid;\n                grid-template-columns: repeat(var(--box-pr-row), auto);\n                grid-gap: var(--large-spacing);\n\n                .box {\n                    display: grid;\n                    grid-template-columns: 1fr auto;\n                    align-items: center;\n                    column-gap: var(--large-spacing);\n                    height: min-content;\n                    padding: var(--large-spacing);\n                    box-sizing: border-box;\n                    border-radius: var(--border-radius);\n                    background-color: var(--motes-light-gray);\n                    text-align: left;\n                    cursor: pointer;\n\n                    h4, p {\n                        font-size: 16px;\n                        line-height: 22px;\n                    }\n\n                    h4 {\n                        display: flex;\n                        align-items: center;\n                        justify-content: space-between;\n                    }\n\n                    p {\n                        margin: 0;\n                        overflow: hidden;\n                        max-height: 0;\n                        transition: .2s max-height;\n                    }\n\n                    svg-icon {\n                        transition: 0.2s transform;\n                    }\n\n                    &.open {\n                        p {\n                            max-height: 100px;\n                        }\n\n                        svg-icon {\n                            transform: rotate(180deg);\n                        }\n                    }\n                }\n            }\n\n            .tour-summary {\n                margin-bottom: var(--medium-spacing);\n\n                p {\n                    font-size: 16px;\n                }\n            }\n        }\n    }\n    \n    .first-section {\n        #media-container {\n            height: 100%;\n\n            .image-container {\n                height: 100%;\n\n                img {\n                    height: 100%;\n                    object-fit: cover;\n                }\n            }\n        }\n    }\n\n    .start-tour-overlay {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n    }\n\n    .start-tour-drawer {\n        position: fixed;\n        z-index: 1;\n        bottom: -500px;\n        transition: 0.5s bottom;\n        width: 100%;\n        border-radius: 20px 20px 0 0;\n        padding: 20px;\n        box-sizing: border-box;\n        box-shadow: 0px -5px 15px #22222273;\n\n        &.open {\n            bottom: 0;\n        }\n\n        .start-tour-option {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n\n            h3 {\n                flex: 1;\n                margin-bottom: 10px;\n                margin-right: 10px;\n            }\n            \n            button {\n                width: 120px;\n            }\n\n            svg-icon {\n                width: 50px;\n                height: 50px;\n                margin-right: var(--motes-padding);\n                border-radius: var(--border-radius);\n                text-align: center;\n                display: flex;\n                align-items: center;\n                background-color: white;\n                \n                svg {\n                    width: 68%;\n                    height: 68%;\n                }\n\n                &[name='motes'] {\n                    background-color: black;\n                    color: white;\n\n                    svg {\n                        width: 70%;\n                        height: 70%;\n                    }\n                }\n            }\n        }\n    }\n\n    // desktop view\n    @media only screen and (min-width: 1025px) {\n        .first-section {\n            .section > .sub-section.padded-left {\n                padding-top: 2vh;\n                padding-bottom: 2vh;\n            }\n\n            h1 {\n                margin-top: 0;\n                font-size: 35px;\n                line-height: 43px;\n            }\n\n            .icons p {\n                font-size: 16px;\n                line-height: 23px;\n            }\n\n            .language-container {\n                padding-top: var(--header-height);\n            }\n        }\n    }\n\n    // tablet view\n    @media only screen and (max-width: 1025px) {\n        .first-section {\n            .icons svg-icon {\n                    font-size: 25px;\n            }\n        }\n    }\n\n    // Mobile view\n    @media only screen and (max-width: 600px) {\n        .section .sub-section {\n        \n            &.dynamic-text {\n                width: initial;\n\n                .product-container {\n                    flex-wrap: wrap;\n\n                    mini-voucher {\n                        width: 100%;\n                        margin: 0;\n                    }\n                }\n            }\n\n            &.image.map {\n                height: 50vh;\n                \n                motes-media {\n                    height: 100%;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
